<template>
	<header :class="['header', { 'loggedIn': isLoggedIn , 'dark-mode': isDarkMode }]">
		<div class="container-fluid">
			<div class="aside">
			<!-- LEFT: Logo and Menu Toggle -->
				<div class="logo-aside d-flex align-items-center">
					<router-link to="/dashboard" class="d-flex align-items-center text-decoration-none">
						<img :src="logoOnlySrc" alt="Logo" class="logo" />
						<span class="company-text text-nowrap fs-5">TENNY ENTERPRISES, INC.</span>
					</router-link>
					<p class="fa-solid fa-bars mb-0 ms-3" v-on:click="toggleAsideMenu"></p>
				</div>

				<!-- RIGHT: User menu and Notifications -->
				<nav class="navbar right-menu">
					<ul class="navbar-nav d-flex flex-row align-items-center gap-3">
						<li class="nav-item dropdown" v-on:click.stop>
							<span class="user d-flex" v-on:click="toggleUserMenu">
							<a class="isLoggedIn && $route.path !== '/'">
								<font-awesome-icon icon="circle-user" class="f-aws" />
								<span class="user-name">
									{{ isSuperAdmin ? '' : 'MERCHANT -' }} {{ loggedUser?.user_name }}
								</span>
							</a>
							</span>
							<div ref="userMenu" v-if="isUserMenu">
							<ul class="dropdown-menu">
								<li class="dropdown-item" v-on:click="toggleUserMenu">
								<router-link to="/my-account">
									<font-awesome-icon icon="fa-solid fa-id-badge" class="me-2" /> My Account
								</router-link>
								</li>
								<li class="dropdown-item" v-on:click="toggleUserMenu">
								<router-link to="/change-password">
									<font-awesome-icon icon="fa-solid fa-key" class="me-2" /> Change Password
								</router-link>
								</li>
								<li class="dropdown-item" v-on:click="logout">
								<a><font-awesome-icon icon="fa-solid fa-power-off" class="me-2" />Logout</a>
								</li>
							</ul>
							</div>
						</li>
						<li class="nav-item">
							<router-link to="/notifications">
							<div class="notif-wrapper me-1">
								<font-awesome-icon icon="fa-solid fa-bell" class="f-aws" />
							</div>
							</router-link>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	</header>
	<LoginView v-if="showLoginModal" @close="closeLoginModal" />
</template>

<script src="./HeaderScript.vue"/>